import { GoPlusCircle, GoQuestion } from "react-icons/go";
import { IoIosNotificationsOutline } from "react-icons/io";
import { BsChatText } from "react-icons/bs";
import userLogo from "../../assets/user.jpeg";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { MdLogout } from "react-icons/md";
import { LuUserCircle2 } from "react-icons/lu";
import { useEffect, useState } from "react";
import apiClient from "../../service/Axios";

const Navbar = () => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState();
  const handleLogOut = () => {
    // console.log("hello");
    localStorage.removeItem("usersInfo");
    localStorage.removeItem("usersData");
    localStorage.removeItem("usersAccessTocken");
    toast.success("Successfully logout");
    navigate("/login");
  };

  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_AUTHENTICATION_API}/user/profile`)
      .then((res) => {
        // console.log("profile data", res.data);
        setProfileData(res.data);
      });
  }, []);

  return (
    <nav className="flex justify-end py-2.5 px-4 border-0 border-b">
      <div className="text-[22px] flex justify-center items-center gap-[22px] text-[#161B22] divide-x divide-stone-800">
        <div className="flex justify-center gap-5 items-center">
          <GoPlusCircle />
          <IoIosNotificationsOutline className="text-2xl" />
          <GoQuestion />
          <BsChatText />
        </div>
        {localStorage.getItem("usersInfo") ? (
          <div className="dropdown dropdown-end">
            <div
              className="flex items-center gap-2 pl-4"
              tabIndex={0}
              role="button">
              <div className="avatar">
                <div className="w-8 rounded-full border border-black">
                  <img src={userLogo} alt="" />
                </div>
              </div>
              <div className="text-[14px] leading-5">
                <p className="font-semibold text-[#161B22]">
                  {profileData?.name.charAt(0).toUpperCase() +
                    profileData?.name.slice(1)}
                  {/* {profileData?.name.charAt(0).toUpperCase() +
                    profileData?.name.slice(1)} */}
                </p>
                <p className="text-[13px] text-[#161B22]">Co Founder</p>
              </div>
            </div>

            <ul
              tabIndex={0}
              className="mt-3 z-[1] shadow menu menu-sm dropdown-content bg-[#161b22] rounded-md w-52">
              <li>
                <Link
                  to="/profile"
                  className="flex justify-start items-center gap-2 text-white new rounded-none py-2">
                  <LuUserCircle2 className="text-[16px]" /> Profile
                </Link>
              </li>

              <li>
                <Link
                  className="flex justify-start items-center gap-2 rounded-none text-white new py-2"
                  to="/login"
                  onClick={handleLogOut}>
                  {" "}
                  <MdLogout /> Logout
                </Link>
              </li>
            </ul>
          </div>
        ) : (
          <div className="flex items-center gap-4 pl-4 text-gray-800">
            <Link to="/login">
              <button className="text-[16px]">Sign in</button>
            </Link>
            <Link to="/register">
              <button className="rounded-md border border-gray-600 px-2 py-1 text-[16px]">
                Sign Up
              </button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
